(function(algolia) {
  'use strict';
  algolia.translations = {
    searchTitle: 'Resultados de la búsqueda',
    search: 'Búsqueda actual',
    allProducts: 'Ver todos los resultados ',
    matching: 'matching',
    sortBy: 'Ordenado por',
    relevance: 'Relevancia',
    outOf: 'de un total de',
    resultsFound: 'Resultados encontrados',
    oneResultFound: '1 resultado encontrado',
    noResultFound: 'No se encontraron resultados',
    addToCart: 'Añadir al carrito',
    searchForProduct: 'Buscar productos',
    selectedFilter: 'Filtros seleccionados',
    clearAll: 'Borrar todo',
    outOfStock: 'Agotado',
    products: 'Productos',
    collections: 'Collecciones',
    articles: 'Articulos',
    pages: 'Páginas',
    try: 'Intento',
    clearFilters: 'Limpiar filtros',
    or: 'o',
    changeInput: 'cambiando su input',
    showLess: 'Mostrar menos',
    showMore: "mostrar mas",
    didYouMean: 'Querías decir?',
    drawerSearchResultsTitleEmpty: 'Productos en tendencia',
    drawerSearchResultsTitle: 'Resultados más relevantes para',
    drawerQuerySuggestionsTitle: 'Querías decir?',
    drawerQuerySuggestionsTitleEmpty: 'Categorías populares'
  };

  algolia.translation_helpers = {
    no_result_for: function(text) {
      return 'No se encontraron resultados para " ' + text + ' ".';
    },
    in: function(processingTimeMS) {
      return 'en ' + processingTimeMS / 1000 + 's';
    },

    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ' para un total de'
      );
    },

    by: function(text) {
      if (!text) return '';
      return ' por ' + text;
    },

    render_title: function(text, query){
      if (text === 'Productos' && query) {
        return text + ' para ' + query;
      }
      return text;
    },
  };
})(window.algoliaShopify);
